// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { StorageSharedKeyCredential } from "@azure/storage-blob";
